import { render, staticRenderFns } from "./SectionMain.vue?vue&type=template&id=68c68782&scoped=true&"
import script from "./SectionMain.vue?vue&type=script&lang=js&"
export * from "./SectionMain.vue?vue&type=script&lang=js&"
import style0 from "./SectionMain.vue?vue&type=style&index=0&id=68c68782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c68782",
  null
  
)

export default component.exports